// extracted by mini-css-extract-plugin
module.exports = {"root":"ResultsBar_root__23RSZ","link":"ResultsBar_link__3EtEo","dark":"ResultsBar_dark__1ynXL"};